import type { IPublicClientApplication } from "@azure/msal-browser";
import type { BucketSelection, FacetFilter } from "../../types";
import { SUB_FACETS_STALE_TIME } from "../subFacetsQuery";
import { fetchAssets } from "./fetchAssets";

export const assetsQueryOptions = ({
    instance,
    index,
    selected,
    dateFilters = [],
}: {
    instance: IPublicClientApplication;
    index: string;
    selected?: BucketSelection;
    dateFilters?: FacetFilter[];
}) => ({
    queryKey: [
        "overview-assets",
        index,
        selected?.field ?? "",
        selected?.value ?? "",
        ...dateFilters.flatMap((filter) => [filter.key, ...filter.value]),
    ],
    queryFn: () =>
        fetchAssets({
            instance,
            index,
            filters: selected ? [selected] : [],
            dateFilters,
        }),
    staleTime: SUB_FACETS_STALE_TIME,
});
